export default __webpack_public_path__ + "static/media/aqi-poor.27f32171.svg";